import { render, staticRenderFns } from "./MoreGroupBuy.vue?vue&type=template&id=6099d8f1&"
import script from "./MoreGroupBuy.vue?vue&type=script&lang=js&"
export * from "./MoreGroupBuy.vue?vue&type=script&lang=js&"
import style0 from "./MoreGroupBuy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports